import i18next from 'i18next'
import React, { useState, useEffect } from 'react'
import { BaseBottomSheet } from '../../ui/BaseBottomSheet'
import { popToast } from '../../ui/Toaster'
import { BlockQuote } from '../../ui/BlockQuote'

type Props = {
    onSubmit: (message: string) => void
    onClose: () => void
    open: boolean
    elementLabel?: string
}

export function FeedbackSubmission({ onSubmit, onClose, open, elementLabel }: Props) {
    const [message, setMessage] = useState('')

    useEffect(() => {
        setMessage('')
    }, [open])

    function empty() {
        return message.trim() === ''
    }

    function submit() {
        if (empty()) {
            return
        }
        onSubmit(message)
        onClose()
        popToast({
            icon: 'checkmark-in-circle',
            message: i18next.t('appcore:WorkflowFeedback.submitted'),
            duration: 5000,
        })
    }

    return (
        <BaseBottomSheet
            isOpen={open}
            onClose={onClose}
            title={i18next.t('appcore:WorkflowFeedback.title')}
            size={'auto'}
        >
            <div className={'AppCore__flow__FeedbackSubmission'}>
                {elementLabel && <BlockQuote>{elementLabel}</BlockQuote>}
                <textarea
                    data-testid={'feedback-input'}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder={i18next.t('appcore:WorkflowFeedback.inputPlaceholder')}
                    rows={3}
                />
                <div className={'AppCore__flow__FeedbackSubmission-buttons'}>
                    <zaptic-button type={'secondary'} size={'large'} onClick={onClose}>
                        {i18next.t('appcore:common.cancel')}
                    </zaptic-button>
                    <zaptic-button
                        type={'primary'}
                        size={'large'}
                        onClick={submit}
                        disabled={empty()}
                        data-testid={'feedback-submit-button'}
                    >
                        {i18next.t('appcore:common.send')}
                    </zaptic-button>
                </div>
            </div>
        </BaseBottomSheet>
    )
}
